<template>
  <v-container fluid class="pt">
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white shadow justify-center align-center py-2 px-3"
    >
      <h3 class="px-2">{{ $t("notification_report") }}</h3>
      <v-autocomplete
        outline
        singleLine
        hideDetails
        autocomplete
        class="mx-2"
        item-value="id"
        item-text="name"
        @change="initData"
        v-model="branch_id"
        :disabled="loading"
        :items="branch_filters"
        style="max-width: 300px"
        :placeholder="$t('branch')"
        v-if="userCan('view_all_branches_report')"
      />
      <v-spacer class="hidden-sm-and-down" />
      <!-- <v-date
              singleLine
              solo-inverted
              :hideDetails="true"
              :clearable="false"
              @input="initData"
              format="YYYY-MM-DD"
              v-model="start_date"
              :disabled="loading"
              value-type="YYYY-MM-DD"
              :placeholder="$t('date')"
              input_id="start_date_lctr"
              class="mx-2 flex xs12 md2 hide-details"
            /> -->
      <v-date
        singleLine
        :hideDetails="true"
        :clearable="false"
        @input="initData"
        v-model="end_date"
        :disabled="loading"
        format="YYYY-MM-DD"
        input_id="end_date_lctr"
        value-type="YYYY-MM-DD"
        :placeholder="$t('date')"
        class="mx-2 flex xs12 md2 hide-details"
      />
      <!-- style="max-width:250px;" -->

      <!-- <v-flex xs12 class="di-flex justify-center align-end">
      <v-text-field
          outline
          hide-details
          class="rounded"
          v-model="search"
          prepend-inner-icon="search"
          :placeholder="$t('bill_number')"
        />

      </v-flex> -->
    </v-layout>
    <v-layout row wrap>
      <v-card class="elevation-0 shadow-md white mt-2 flex xs12">
        <v-card-text class="pt-3">
          <div class="di-flex flex align-center mb-3">
            <h3 class="px-2">
              {{ $t("customers_overbalanced") }}
            </h3>
            <v-spacer></v-spacer>
            <v-text-field
              outline
              hide-details
              v-model="search"
              style="max-width: 400px"
              class="flex xs12 rounded"
              :placeholder="$t('search')"
              prepend-inner-icon="search"
            />
            <v-btn
              color="grey darken-2"
              class="mx-0"
              flat
              icon
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              color="grey darken-2"
              class="mx-0"
              flat
              icon
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              class="mx-0"
              @click="initData"
              :loading="loading"
              color="grey darken-2"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </div>
          <v-data-table
            ref="tbl"
            item-key="id"
            :items="items"
            :search="search"
            class="flex xs12"
            :loading="loading"
            :headers="headers"
            v-model="selected"
          >
            <template slot="items" slot-scope="{ item, index }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.id }}</td>
                <td>
                  <router-link
                    :to="`${item.type}s/${item.id}?type=${item.type}`"
                    >{{ `${item.name} ` }}</router-link
                  >
                </td>
                <td>{{ item.pretty_phone }}</td>
                <td>{{ $t(item.type) }}</td>
                <td class="font-weight-bold">
                  {{
                    item.balance | currency({ symbol: smbl(item.currency_id) })
                  }}
                </td>
                <td>
                  <v-btn
                    flat
                    icon
                    small
                    class="ma-0"
                    color="grey darken-1"
                    @click="
                      $router.push(`${item.type}s/${item.id}?type=${item.type}`)
                    "
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import curjs from "currency.js";
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 1);
export default {
  mixins: [customersMixin],
  props: ["type", "is_bank"],
  data() {
    return {
      items: [],
      search: "",
      selected: [],
      loading: false,
      customer: {},
      branch_id: "",
      branch_filters: [],
      end_date: new Date().toLocaleDateString("en-ca"),
      start_date: currentDate.toLocaleDateString("en-ca"),
    };
  },

  computed: {
    currencies() {
      return this.initialData.currencies;
    },
    selectedBranch: (vm) =>
      vm.branch_filters.filter((x) => x.id == vm.branch_id) || {},
    headers: (vm) => {
      let items = [
        {
          value: "index",
          width: "100px",
          sortable: false,
          text: vm.$t("number"),
        },
        {
          value: "id",
          sortable: false,
          text: vm.$t("account_number"),
        },
        {
          value: "name",
          sortable: false,
          text: vm.$t("name"),
        },
        {
          value: "pretty_phone",
          sortable: false,
          text: vm.$t("phones"),
        },
        {
          value: "type",
          sortable: false,
          text: vm.$t("type"),
        },
        {
          value: "balance",
          sortable: false,
          text: vm.$t("balance"),
          computed: (item) =>
            curjs(item.balance).format({ symbol: vm.smbl(item.currency_id) }),
        },
      ];
      items.push({
        sortable: false,
        value: "actions",
        text: vm.$t("actions"),
      });
      return items;
    },
    // total() {
    //   let barrow = { name: "مجموع طلب" };
    //   let loan = { name: "مجموع قروض" };

    //   this.items.forEach(item => {
    //     this.currencies.forEach(currency => {
    //       if (
    //         item.mapped_accounts[currency.id] &&
    //         item.mapped_accounts[currency.id].balance < 0
    //       )
    //         loan[currency.id] =
    //           (loan[currency.id] || 0) +
    //           Number(item.mapped_accounts[currency.id].balance);
    //       else if (
    //         item.mapped_accounts[currency.id] &&
    //         item.mapped_accounts[currency.id].balance > 0
    //       )
    //         barrow[currency.id] =
    //           (barrow[currency.id] || 0) +
    //           Number(item.mapped_accounts[currency.id].balance);
    //     });
    //   });
    //   return { loan, barrow };
    // }
  },
  methods: {
    getBranches() {
      this.axios.get("branches").then((res) => {
        this.branch_filters = res.data;
      });
    },
    initData() {
      this.loading = true;
      let { search, branch_id, type, end_date, start_date } = this;
      let params = {
        type,
        search,
        end_date,
        branch_id,
        start_date,
        twoMonthsAlert: true,
        is_bank: this.is_bank || false,
      };
      this.axios
        .get(`reports`, { params })
        .then((resp) => {
          this.items = resp.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    printTable(excel) {
      let data = {
        landscape: true,
        headers: this.headers.slice(1, -1),
        title: this.$t(`customers_overbalanced`),
        items: this.$refs.tbl.filteredItems,
        brnch_name: this.selectedBranch.name,
      };

      if (excel)
        return this.xl_tables(data, "notifications", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
  created() {
    this.branch_id = this.userBranch.id;
    this.initData();
    this.getBranches();
  },
};
</script>